import { render, staticRenderFns } from "./hot-search.vue?vue&type=template&id=5d44a024&scoped=true&"
import script from "./hot-search.vue?vue&type=script&lang=js&"
export * from "./hot-search.vue?vue&type=script&lang=js&"
import style0 from "./hot-search.vue?vue&type=style&index=0&id=5d44a024&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44a024",
  null
  
)

export default component.exports